import { renderSlot as _renderSlot, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", {
        onDrop: _cache[0] || (_cache[0] = _withModifiers(
        //@ts-ignore
        (...args) => ($options.onDrop && $options.onDrop(...args)), ["prevent", "stop"])),
        onDragenter: _cache[1] || (_cache[1] = _withModifiers(($event) => ($options.onDragOver(true)), ["prevent", "stop"])),
        onDragleave: _cache[2] || (_cache[2] = _withModifiers(($event) => ($options.onDragOver(false)), ["prevent", "stop"])),
        onDragover: _cache[3] || (_cache[3] = _withModifiers(() => { }, ["prevent", "stop"]))
    }, [
        _renderSlot(_ctx.$slots, "default")
    ], 32));
}
